import { useMemo } from 'react'
import { ItemDataTextProps } from 'store/types'

function PostItemText({ text, backgroundColor, color, bold, italic, underline, lineThrough }: ItemDataTextProps) {
  const lineStyle = useMemo(() => {
    if (underline && lineThrough) return ' [text-decoration:underline_line-through]'
    if (underline) return ' underline'
    if (lineThrough) return ' line-through'
    return ''
  }, [underline, lineThrough])

  return (
    <div
      className='w-full h-full overflow-hidden'
      style={{
        backgroundColor
      }}>
      <div className='flex flex-col items-center justify-center h-full'>
        {text.split('\n').map((textLine, index) => (
          <svg key={index} viewBox='0 0 20 20' height='100%' width='100%'>
            <text
              className={`${bold ? ' font-bold' : ''}${italic ? ' italic' : ''}${lineStyle}`}
              style={{
                fill: color
              }}
              x='50%'
              y='55%'
              dominantBaseline='middle'
              textAnchor='middle'>
              {textLine}
            </text>
          </svg>
        ))}
      </div>
    </div>
  )
}

export default PostItemText
